import Dialog from './Dialog.js';

class ActivationRequiredDialog extends Dialog {
    static create(params) {
        return new ActivationRequiredDialog(params);
    }

    constructor({id, env}) {
        super({id, autoInitEvents: false});

        this.signInButton = this.find('.sign-in-button');
        this.resendEmailButton = env.getDecorator().spinnerButton(this.find('.resend-button'));

        this.initEvents();
    }

    initEvents() {
        super.initEvents();

        this.signInButton.click(() => this.maybeTrigger('signInButton:click'));
        this.resendEmailButton.click(() => this.maybeTrigger('resendEmailButton:click'));
    }

    setSubmitting(submitting) {
        this.setEventsEnabled(!submitting);
        this.resendEmailButton.toggleSpinner(submitting);
    }
}

export default ActivationRequiredDialog;